import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/building_types/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listBuildingTypes, updateBuildingType } from "../../../redux/actions/table/superadmin/building_types";
import EditBuildingTypeForm from "../../../forms/superadmin/building_types/EditBuildingTypeForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateBuildingType(formData.id, _.omit(formData, ['id'])).then(() => {
                listBuildingTypes();

                this.props.readAction(formData.id);

                setNotification(__('space-allocation-beta.buildings.flyout.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditBuildingTypeForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
